export const notificationOptions = {
	icon: '/favicon.png',
	dir: 'rtl',
	lang: 'en-US',
};

// TODO: أضف أنواع إشعارات Octopharma ومسار الانتقال لكل نوع
export const notificationPageRedirect = [];

// TODO: صفحات لا يُعرض فيها الإشعار المنبثق (مثلاً صفحة الإشعارات نفسها)
export const preventedPagesFromNotification = [];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyACgWDM6o09L-g9fjhbxzLYx12vvrvjvvo',
		authDomain: 'octopharma.firebaseapp.com',
		projectId: 'octopharma',
		storageBucket: 'octopharma.firebasestorage.app',
		messagingSenderId: '935948786255',
		appId: '1:935948786255:web:9742a80351dacf78daa83a'
	},
	publicKey: 'BK_skQn_5l9moKDh_AqOUMTZV8wNPSiLAa1b5GX893rWmFi1syMCVQ1spDinLUu3vv0s_80Wp2eKNn_W1IZStdw',
};
